module.exports = __webpack_public_path__ + "img/privacy.1c3a251e.png";